import { Component, Inject, OnInit } from '@angular/core';
import { ComponentBase } from '../../_infrastructure/classes/componentBase';
import { tap, catchError, of } from 'rxjs';
import { ExceptionManager } from '../../_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../_infrastructure/classes/services/notification.service';
import { AClaveRequest, ERROR_CLAVE_KEYS } from '../../_infrastructure/types/aclave';
import { LoggedUserViewModel } from '../../_infrastructure/types/common';
import { ArrobaClaveService } from '../../_infrastructure/classes/services/arroba-clave.service';
import { BROADCAST_SERVICE } from 'src/app/app.module';
import { BroadcastService } from '../../_infrastructure/classes/services/broadcast.service';
import { BroadcastTypes } from '../../_infrastructure/types/broadcast';
import { SolicitudService } from 'src/app/components/_importacion/solicitudes/datosbasicos/datosbasicos.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-logout-clave',
    templateUrl: './logout-clave.component.html',
    styleUrls: ['./logout-clave.component.scss'],
})
export class LogoutClaveComponent extends ComponentBase implements OnInit {
    aClaveRequest = new AClaveRequest();

    constructor(
        @Inject(BROADCAST_SERVICE) private broadcastService: BroadcastService,
        private router: Router,
        private solicitudService: SolicitudService,
        private arrobaClaveService: ArrobaClaveService,
        protected authService: AuthService,
        protected notificationService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.authService.logout$.subscribe(() => {
            this.doLogoutClave();
        });
    }

    private broadCastLogout(): void {
        // Para cerrar la sesión en todas las pestañas abiertas
        this.broadcastService.publish({
            type: BroadcastTypes.LOGOUT,
        });
    }

    /**
     * Este método primero invoca al servicio que devuelve la petición de LOGOUT firmada con el certificado,
     * para posteriormente remitirla por POST a Cl@ve.
     * aClaveRequest contiene los datos con los que se rellena el form que se envía a Cl@ve.
     */
    private doLogoutClave(): void {
        const usuario: LoggedUserViewModel | null = this.authService.getLoggedInUser();

        if (!usuario || !usuario.XmlSignedId) {
            // usuario es null cuando el login no ha tenido éxito.
            this.finalizeLogout(usuario !== null);
            return;
        }
        this.arrobaClaveService
            .doLogoutClave(usuario.XmlSignedId)
            .pipe(
                tap((response: any) => {
                    this.aClaveRequest = response.Result as AClaveRequest;
                    setTimeout(() => {
                        // @author scalero1 - Se hace el POST desde un formulario HTML, porque directamente con http.post
                        // o desde el core, Cl@ve devuelve el error invalid.sp.domain
                        const form = document.querySelector('#formClaveLogout') as HTMLFormElement;
                        form.submit();
                        this.finalizeLogout(true);
                    }, 0);
                }),
                catchError(error => {
                    if (error) {
                        this.finalizeLogout(true, '/error/' + ERROR_CLAVE_KEYS.UNSUCESSFULL_LOGOUT);
                        this.catchServerError(error);
                    }
                    return of(null);
                }),
            )
            .subscribe();
    }

    private finalizeLogout(verbose: boolean, errorUrl: string = ''): void {
        if (verbose) {
            this.notificationService.addSuccessMessage('Sesión finalizada');
        }
        if (errorUrl !== '') {
            this.router.navigateByUrl(errorUrl);
        } else {
            this.router.navigate(['/home']);
        }
        this.broadCastLogout();
        this.solicitudService.setParamsSolicitud(null);
        this.authService.setAuth(null);
    }
}
